import { render, staticRenderFns } from "./tgDhAdminSettings.vue?vue&type=template&id=348ee9f8&scoped=true"
import script from "./tgDhAdminSettings.vue?vue&type=script&lang=ts"
export * from "./tgDhAdminSettings.vue?vue&type=script&lang=ts"
import style0 from "./tgDhAdminSettings.vue?vue&type=style&index=0&id=348ee9f8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348ee9f8",
  null
  
)

export default component.exports